import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import {
  Table,
  TableHeader,
  TableRow,
  TableHeaderCell,
} from "../../styled-components/Table";
import { CloseButton } from "../../styled-components/";
import AppSettings from "../../constants/app";

const OverlayTableContainer = styled.div`
  width: 75%;
  height: 10.5rem;
  display: ${(props) => (props.visible ? "block" : "none")};
  position: fixed;
  bottom: ${AppSettings.FOOTER_HEIGHT};
  left: ${(props) => props.left || "0"};
  background-color: ${(props) => props.theme.table.background};
  z-index: 3;
`;

const TableContainer = styled.div`
  height: 8rem;
  overflow-y: scroll;
`;

const HeaderBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-color: ${(props) => props.theme.table.header};
  padding-left: 0.5rem;
  color: ${(props) => props.theme.text.primary};
  height: 1.25rem;
`;

const HeaderCloseButton = styled.div`
  margin-left: auto;
`;

const HeaderContainer = styled.div`
  padding-right: 0;
  background-color: ${(props) => props.theme.table.header};
`;

class OverlayTable extends Component {
  render() {
    return (
      <OverlayTableContainer
        left={this.props.left}
        visible={this.props.visible}
      >
        <HeaderBar>
          {this.props.title}
          <HeaderCloseButton>
            <CloseButton
              fontSize="16px"
              height="1.3rem"
              onClick={this.props.close}
            >
              &times;
            </CloseButton>
          </HeaderCloseButton>
        </HeaderBar>
        <HeaderContainer>
          <Table width="100%">
            <TableHeader>
              <TableRow>
                {this.props.header.map((h) => (
                  <TableHeaderCell key={h.title} width={h.width} bold>
                    {h.title}
                  </TableHeaderCell>
                ))}
              </TableRow>
            </TableHeader>
          </Table>
        </HeaderContainer>
        <TableContainer>{this.props.children}</TableContainer>
      </OverlayTableContainer>
    );
  }
}

OverlayTable.defaultProps = {
  title: "",
  visible: false,
  close: () => {},
  header: [],
  children: {},
  left: null,
};

OverlayTable.propTypes = {
  title: PropTypes.string,
  visible: PropTypes.bool,
  close: PropTypes.func,
  header: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      width: PropTypes.string,
    })
  ),
  children: PropTypes.element,
  left: PropTypes.string,
};

export default OverlayTable;



// WEBPACK FOOTER //
// ./app/components/DeliveryStatus/OverlayTable.js